export default {
	// green to red
	approvalColors: [
		"#BB0000",
		"#BB2900",
		"#BB5300",
		"#BB7C00",
		"#BBA600",
		"#A6BB00",
		"#7CBB00",
		"#53BB00",
		"#29BB00",
		"#00BB00",
	],

	initFor(knobSelector, linkedButtonSelector) {
		pp.log(
			"init approval rating knob, selector:",
			knobSelector,
			"targets:",
			$(knobSelector),
			linkedButtonSelector,
		);
		$.each($(knobSelector), function () {
			// @ts-expect-error
			$(this).knob({
				fgColor:
					pp.approvalRatings.approvalColors[parseInt(this.value, 10) + 4],
				rotation:
					I18n.t("meta.direction") == "rtl" ? "clockwise" : "anticlockwise",
				change(value) {
					const val = parseInt(value, 10) + 5;
					this.o.fgColor = pp.approvalRatings.approvalColors[val - 1];
					if (linkedButtonSelector !== undefined) {
						$(linkedButtonSelector).prop("disabled", false);
					}
				},
			});
		});
	},

	initDetailFor(knobSelector) {
		pp.log(
			"init approval rating *detail* knob, selector:",
			knobSelector,
			"targets:",
			$(knobSelector),
		);
		$.each($(knobSelector), function () {
			// @ts-expect-error
			$(this).knob();
		});
	},
};
